import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Lenspire_Icon_Search",
  "use": "Lenspire_Icon_Search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"Lenspire_Icon_Search\">\n<path d=\"M23.707,22.291l-4.23-4.23c1.593-1.91,2.552-4.365,2.552-7.046C22.028,4.931,17.098,0,11.015,0S0,4.931,0,11.014\n\tc0,6.083,4.932,11.015,11.015,11.015c2.681,0,5.137-0.961,7.046-2.553l4.23,4.23C22.486,23.902,22.742,24,22.999,24\n\tc0.256,0,0.512-0.098,0.708-0.293C24.098,23.315,24.098,22.682,23.707,22.291z M2.003,11.014c0-4.969,4.042-9.012,9.012-9.012\n\tc4.969,0,9.012,4.043,9.012,9.012c0,4.969-4.043,9.011-9.012,9.011C6.045,20.025,2.003,15.983,2.003,11.014z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Lenspire_Icon_Search.svg
// module id = 583
// module chunks = 0